import request from '@/utils/request'

// 查询列表
export function apiScpMrpSuppliesList (data) {
  return request({
    url: '/scp/scpMrpSupplies/list',
    method: 'post',
    data: data
  })
}

// 数据收集时间、叫料计算完成时间
export function apiScpMrpPlansCallMaterialPlanExecutionTime (query) {
  return request({
    url: '/scp/scpMrpPlans/callMaterialPlanExecutionTime',
    method: 'get',
    params: query
  })
}

// 计划版本
export function apiScpMrpPlansPlanVersionBox (query) {
  return request({
    url: '/scp/scpMrpPlans/planVersionBox',
    method: 'get',
    params: query
  })
}

// 物料类别
export function apiScpMrpCategoryCodeCategoryBox (query) {
  return request({
    url: '/scp/scpMrpCategoryCode/categoryBox',
    method: 'get',
    params: query
  })
}

// 筛选方案列表
export function apiScpScreeningSchemeSearchAllScheme (query) {
  return request({
    url: '/scp/scpScreeningScheme/searchAllScheme',
    method: 'get',
    params: query
  })
}

// 发布
export function apiScpMrpSuppliesRelease (data) {
  return request({
    url: '/scp/scpMrpSupplies/release',
    method: 'put',
    data: data
  })
}

// 导出列表
export function apiScpMrpSuppliesNewExport (data) {
  return request({
    url: '/scp/scpMrpSupplies/v2/export',
    method: 'post',
    data: data
  })
}

// 整版发布
export function apiScpMrpSuppliesFullVersionRelease (data) {
  return request({
    url: '/scp/scpMrpSupplies/fullVersionRelease',
    method: 'put',
    data: data
  })
}
